import  CompetitionAssessmentModal from './CompetitionAssessmentModal';

export default CompetitionAssessmentModal;